module.exports = __webpack_public_path__ + "img/មាន់ជល់ហ្វីលីពីន.bab4c4c5.png";